import { PlusIcon } from "@radix-ui/react-icons";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

import { Button } from "@/components/ui/button/button";
import { getAllCompanyHolidayListsQueryOptions } from "@/config/queries/query-options";
import { columns } from "./_components/company-holiday-list-table/columns";
import { DataTable } from "./_components/company-holiday-list-table/data-table";
import { Spinner } from "@/components/ui/spinner/spinner";

const AdminCompanyHolidaysPage = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending, isFetching } = useQuery(
    getAllCompanyHolidayListsQueryOptions(user)
  );

  const companyHolidaysListData = useMemo(() => {
    if (isPending || isFetching) {
      return [];
    }

    if (data === undefined || data?.foundLists === undefined) {
      return [];
    }

    const result = data?.foundLists?.map((list) => {
      return {
        id: list?._id,
        name: list?.name,
        year: list?.year,
        holidayCount: list?.holidays?.length || 0,
        isActive: list?.isActive,
      };
    });

    return result;
  }, [data, isPending, isFetching]);

  return (
    <div className="p-5 h-[calc(100%-56px)]">
      <div className="flex items-center justify-between">
        <h3 className="text-2xl font-medium">Company Holidays</h3>

        <Button className="flex items-center gap-1" asChild>
          <Link to="/admin/company-holidays/new">
            <PlusIcon />
            <span>Add Company Holiday List</span>
          </Link>
        </Button>
      </div>

      {isPending ? (
        <div className="h-20 mt-10 flex items-center justify-center">
          <Spinner size="small">
            <p>Loading...</p>
          </Spinner>
        </div>
      ) : data?.foundLists?.length ? (
        <div className="mt-5">
          <DataTable data={companyHolidaysListData} columns={columns} />
        </div>
      ) : (
        <div className="border h-20 mt-5 flex items-center justify-center">
          No company holiday lists found. Create one to get started.
        </div>
      )}
    </div>
  );
};

export default AdminCompanyHolidaysPage;
